import { createContext, useContext } from "react";
import { HubConnectionState } from "../services/signalr";

export interface SignalRContextValue {
  connectionState: HubConnectionState;
}

export const SignalRContext = createContext<SignalRContextValue>({
  connectionState: HubConnectionState.Disconnected,
});

export function useSignalR() {
  return useContext(SignalRContext);
}
